import React from "react";
import {
  PopHeader,
  InfoWrapper,
  QASection,
  DisplayFlexOkay,
  InfoContentWrapper,
  IconWrap,
} from "./styles";
import { GeneralButton } from "../../../../../../../../CommonComponents/Commons/commonComponents";
import { Icon } from "antd";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { wiringInstructionsState } from "../../../../selectors";

class ViewAdditionalInfo extends React.Component {
  render() {
    return (
      <InfoWrapper>
        <InfoContentWrapper>
          <IconWrap>
            <Icon type="close" onClick={this.props.handleOkay} />
          </IconWrap>
          <PopHeader>
          {this.props.drupalData ? (<div dangerouslySetInnerHTML={{__html: this.props.drupalData.wiringInstructions.name}}></div>) : "Wiring Instructions"}
          </PopHeader>
          <QASection>
            {this.props.drupalData ? <div dangerouslySetInnerHTML={{__html: this.props.drupalData.wiringInstructions.description__value}}></div> : ""}
          </QASection>
          <DisplayFlexOkay>
            <GeneralButton 
              text = "OKAY"
              width = "150px"
              mobWidth = "100%"
              onClick={this.props.handleOkay}
            />
            </DisplayFlexOkay>
        </InfoContentWrapper>
      </InfoWrapper>
    );
  }
}

ViewAdditionalInfo.propTypes = {
  drupalData: PropTypes.array
}

const mapStateToProps = state => ({
  ...wiringInstructionsState(state.toJS())
});

export default connect(mapStateToProps, null)(ViewAdditionalInfo);
